import { HTMLProps, PropsWithChildren, PureComponent } from 'react';

export interface SpotInputProps extends HTMLProps<HTMLInputElement> {
    name?: string;
    error?: any;
    [prop: string]: any;
}

export interface Automatable {
    automationId?: string;
}

export class BaseSpotComponent<P = {}, S = {}, SS = {}> extends PureComponent<PropsWithChildren<P>, S, SS> {
    private idSuffix = randomString(4, 5);

    get idProp(): string {
        const { id, name } = this.props as any;
        return id ? `${id}` : `${name}_${this.idSuffix}`;
    }
}

function randomString(min, max): string {
    let iterator;
    const length = Math.floor(Math.random() * (max - min + 1)) + min;
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let text = '';

    for (iterator = 0; iterator < length; iterator += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
